import { ResponsesEmpty } from '@consta/gpn-responses/ResponsesEmpty'
import { Button } from '@consta/uikit/Button'
import { CreateProjectModal } from '@core/components'
import { useState } from 'react'

export const EmptyProjectsPlaceholder = () => {
  const [isDlgVisible, setIsDlgVisible] = useState(false)
  const openDlg = () => {
    setIsDlgVisible(true)
  }
  const closeDlg = () => {
    setIsDlgVisible(false)
  }

  return (
    <>
      <ResponsesEmpty
        description="Будьте первым, создайте проект"
        actions={<Button label="Создать проект" onClick={openDlg} />}
      />

      <CreateProjectModal isModalOpen={isDlgVisible} closeModal={closeDlg} />
    </>
  )
}
